export default __webpack_public_path__ + "static/media/Insights-into-Crypto-Volatility-and-its-Management.5d56dc38.jpg";